import { FC } from 'react';

import error500Icn from 'assets/img/icons/error500-icn.svg';

const ErrorConnection: FC = () =>
  <div className="error-connection-container">
    <img src={error500Icn} alt="connection-error-image" className="m-b-20" />
    <h1 className="m-b-20">No Internet Connection</h1>
  </div>;

export default ErrorConnection;
